import { render, staticRenderFns } from "./CrossCountryObstacleModal.vue?vue&type=template&id=ff682e56&scoped=true"
import script from "./CrossCountryObstacleModal.vue?vue&type=script&lang=ts"
export * from "./CrossCountryObstacleModal.vue?vue&type=script&lang=ts"
import style0 from "./CrossCountryObstacleModal.vue?vue&type=style&index=0&id=ff682e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff682e56",
  null
  
)

export default component.exports